module.exports = __webpack_public_path__ + "static/segundafecha-7dc6b719171d7b3881d5d82364b2cbaa.jpg";